"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordForm = void 0;
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var Yup = __importStar(require("yup"));
var passwordValidator_1 = require("@app/services/passwordValidator");
var YellowButton_1 = require("@app/components/controls/YellowButton");
require("./ResetPasswordForm.scss");
var validationSchema = Yup.object().shape({
    password: Yup.string()
        .trim()
        .required('Please enter a password')
        .test('strength', 'Password does not meet complexity requirements', function (value) { return passwordValidator_1.isStrong(value); }),
    confirmPassword: Yup.string()
        .trim()
        .required('Please confirm your password')
        .oneOf([Yup.ref('password')], 'Passwords do not match')
});
var ResetPasswordForm = function (props) {
    var touched = props.touched, errors = props.errors;
    return (react_1.default.createElement(formik_1.Form, { className: "reset-pass-form" },
        react_1.default.createElement("h1", { className: "is-6 has-text-centered" },
            "Your password MUST be 9 characters long and MUST contain:",
            react_1.default.createElement("ul", null,
                react_1.default.createElement("li", null, "Uppercase character"),
                react_1.default.createElement("li", null, "Lowercase character"),
                react_1.default.createElement("li", null, "Number"),
                react_1.default.createElement("li", null, "Symbol, including  @ $ ! % * ? or &"))),
        react_1.default.createElement("div", { className: "field" },
            react_1.default.createElement("label", { className: "label" }, "Password"),
            react_1.default.createElement(formik_1.Field, { name: "password", type: "password", className: "input", autoFocus: true }),
            touched.password && errors.password &&
                react_1.default.createElement("p", { className: "is-danger help", "data-test": "password-error" }, errors.password)),
        react_1.default.createElement("div", { className: "field" },
            react_1.default.createElement("label", { className: "label" }, "Confirm Password"),
            react_1.default.createElement(formik_1.Field, { name: "confirmPassword", type: "password", className: "input" }),
            touched.confirmPassword && errors.confirmPassword &&
                react_1.default.createElement("p", { className: "is-danger help", "data-test": "confirm-password-error" }, errors.confirmPassword)),
        react_1.default.createElement(YellowButton_1.YellowButton, { type: "submit", className: "button-large", isFullWidth: true },
            react_1.default.createElement("span", { className: "icon" },
                react_1.default.createElement("i", { className: "fas fa-arrow-right" })),
            react_1.default.createElement("span", null, "Continue"))));
};
exports.ResetPasswordForm = ResetPasswordForm;
exports.default = formik_1.withFormik({
    validationSchema: validationSchema,
    mapPropsToValues: function () {
        return {
            password: '',
            confirmPassword: ''
        };
    },
    handleSubmit: function (values, bag) {
        bag.props.onSubmit(values.password, values.confirmPassword);
    }
})(exports.ResetPasswordForm);
